<template>
  <div>
    <clipart-category-field
      v-if="category && category.children"
      :category="category"
      :label="label"
      v-model="selectedCategoryID"
    />
    <cliparts-by-category
      v-if="selectedCategoryID"
      :categoryID="selectedCategoryID"
      :name="layer.id"
      :label="category && category.children ? null : label"
      :required="required"
    />
    <FormulateInput
      v-if="personalizedType !== 'clipartCategory'"
      :name="layer.id"
      :label="label"
      type="imagecropper"
      :aspectRatio="aspectRatio"
    />
  </div>
</template>
<script>
import ClipartCategoryField from './ClipartCategoryField.vue'
import ClipartsByCategory from './ClipartsByCategory.vue'
import { get } from 'lodash'
import { fetchJsonShared } from '@/helper/helper'

export default {
  name: 'image-field',
  components: {
    ClipartCategoryField,
    ClipartsByCategory
  },
  props: {
    layer: {
      type: Object,
      required: true
    },
    artwork: {
      type: Object,
      required: true
    },
    personalized: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      category: null,
      selectedCategoryID: null
    }
  },
  mounted() {
    const { layer, personalizedType } = this
    if (
      personalizedType === 'clipartCategory' &&
      layer.personalized.clipartCategory
    ) {
      fetchJsonShared(
        `${this.$options.AWS_API_CDN}/categories/${layer.personalized.clipartCategory}`
      )
        .then(category => {
          this.category = category
        })
        .catch(error => console.log('error', error))
    }
  },
  watch: {
    category(cat) {
      if (cat.children === null) {
        this.selectedCategoryID = cat.id
      }
    }
  },
  computed: {
    personalizedType() {
      return this.layer.personalized.type
    },
    required() {
      return get(this.layer, 'personalized.required', false)
    },
    initialValue() {
      const { personalized, layer } = this
      return get(personalized, layer.id)
    },
    label() {
      return get(this.layer, 'personalized.label', this.layer.title)
    },
    aspectRatio() {
      const { layer } = this
      return layer.width / layer.height
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Form/ImageField.vue